export default "__VITE_ASSET__CozyIU0Q__"